import React from "react";
import styles from "./MobileUserMenu.module.scss";
import Cancel from "../icons/Cancel";
import { logout } from "../AuthProvider/AuthProvider";
import exitIcon from "../../assets/exit-blue.svg";
import userBlue from "../../assets/userWhite.svg";
import { useTranslation } from "react-i18next";
import api from "../../axiosConfig";
import { getSupportedLocale } from "../../utils/utils";

export type MobileUserMenuProps = {
  userName: string;
  userTitle?: string;
  close: () => void;
  setLanguageSelectionOpen: (value: boolean) => void;
  setFeedbackOpen: (value: boolean) => void;
};

const MobileUserMenu: React.FC<MobileUserMenuProps> = (props: MobileUserMenuProps) => {
  const [locales, setLocales] = React.useState([] as Api.Locale[]);
  const [fetchingLocales, setFetchingLocales] = React.useState(false);
  const [selectedLocaleName, setSelectedLocaleName] = React.useState("...");
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  React.useEffect(() => {
    if (locales.length === 0 && !fetchingLocales) {
      setFetchingLocales(true);
      api.get("localizationids").then((res: any) => {
        setLocales(res.data);

        // Set I18n language to "the supported best guess"
        const locale = getSupportedLocale(i18n.language, res.data as Api.Locale[]);
        if (!!locale) {
          i18n.changeLanguage(locale.locale);
        }
        setSelectedLocaleName(locale?.friendlyName || "Unselected language");
        setFetchingLocales(false);
      });
    }
  });

  return (
    <div className={styles.MobileUserMenuOpen}>
      <>
        <div className={styles.headerRow}>
          <h1>
            <div className={styles.UserMenuToggle}>
              <img className={styles.UserMenuIcon} alt="Menu" src={userBlue} />
              <div className={styles.UserInfo}>
                <span className={styles.UserTitle}>{props.userTitle}</span>
                <span className={styles.UserName}>{props.userName}</span>
              </div>
            </div>
          </h1>
          <div className={styles.Cancel} onClick={() => props.close()}>
            <Cancel />
          </div>
        </div>
        <div className={styles.ItemList}>
          <ul data-tag="languageList">
            <li>
              <a
                href="#"
                onClick={() => {
                  props.setLanguageSelectionOpen(true);
                  props.close();
                }}
              >
                <span className={styles.Locale}>{selectedLocaleName}</span>
                <span className={styles.Caret}>{">"}</span>
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  props.setFeedbackOpen(true);
                  props.close();
                }}
              >
                <span className={styles.Locale}>{t("give_feedback")}</span>
              </a>
            </li>
            <li>
              <a href="#" onClick={() => logout()}>
                <img alt="Log out" src={exitIcon} style={{ height: "16px", width: "26px" }} />
                {t("log_out")}
              </a>
            </li>
          </ul>
        </div>
      </>
    </div>
  );
};

export default MobileUserMenu;
